"use client"

import { HdmiPort } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HdmiPortIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HdmiPortIcon = component(Icon)({ as: HdmiPort })
